/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Input, OnInit} from '@angular/core';
import {TenureService} from '../tenure.service';
import {FormerTenureUiConfig} from '../../../common/models/former-tenure-ui-config';
import {NgClass} from '@angular/common';
import {FormerTenureValidity} from '../../../common/models/former-tenure-validity.model';
import {ParentPlanType} from '../../../common/models/parent-plan-type.model';
import {SubjectLandType} from '../../../common/models/subject-land-type.model';
import {TenureSubjectLandComponent} from '../tenure-subject-land/tenure-subject-land.component';
import {TenureParentPlanTypeComponent} from '../tenure-parent-plan-type/tenure-parent-plan-type.component';
import {TenureParentPlanNumberComponent} from '../tenure-parent-plan-number/tenure-parent-plan-number.component';
import {TenureParentLotsComponent} from '../tenure-parent-lots/tenure-parent-lots.component';
import {Tenure} from '../../../common/models/tenure-model';
import {ControlContainer, NgForm} from '@angular/forms';
import {TenureNewLotDetailComponent} from '../tenure-new-lot-detail/tenure-new-lot-detail.component';

@Component({
    selector: 'nlr-former-tenure-detail',
    imports: [
        TenureSubjectLandComponent,
        TenureParentPlanTypeComponent,
        TenureParentPlanNumberComponent,
        TenureParentLotsComponent,
        TenureNewLotDetailComponent,
        NgClass
    ],
    templateUrl: './former-tenure-detail.component.html',
    styleUrl: './former-tenure-detail.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormerTenureDetailComponent implements OnInit {
    @Input() name: string;
    @Input() tenure: Tenure;
    @Input() formerTenureValidityLookup: FormerTenureValidity;
    @Input() formerTenureUIConfigLookup: FormerTenureUiConfig;
    @Input() parentPlanTypeLookups: ParentPlanType[];
    @Input() subjectLandTypeLookups: SubjectLandType[];
    @Input() tenureDisplayType: string;
    @Input() readonly: boolean;
    labelMap: any;

    constructor(private tenureService: TenureService) {}

    ngOnInit(): void {
        this.labelMap = this.tenureService.getLabelMap(this.formerTenureUIConfigLookup);
    }
}
